import { DecoratorType } from "./DecoratorType";

export const AllowedUse = {
    ADD: DecoratorType.ADD,
    UPDATE: DecoratorType.UPDATE,
    SEARCH: DecoratorType.SEARCH,
    REPORT: DecoratorType.REPORT,
    TASK: DecoratorType.TASK,
    DELETE: "delete" as const,
    LIST: "list" as const,
    LOOKUP: "lookup" as const
} as const;

export type AllowedUse = typeof AllowedUse[keyof typeof AllowedUse];
